<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      telegram-storage(
        :module="moduleItem"
      )
      v-alert(
        v-if="moduleItem.price_per_user === 0"
        type="warning"
      ) Перед отправкой модуля на биржу обратите внимание, что цена модуля равняется нулю!
      v-switch(
        :input-value="moduleItem.status"
        color="secondary"
        rounded
        text
        inset
        outlined
        :false-value="2"
        :true-value="1"
        :persistent-hint="fieldsSaved.status"
        :hint="fieldsSaved.status && 'Сохранено'"
        label="Отображать на бирже"
        @change="update('status', $event)"
      )
    v-col(cols=12)
      .mb-3: strong Наименование
      v-text-field(
        :value="moduleItem.name"
        placeholder="Наименование"
        filled
        rounded
        :persistent-hint="fieldsSaved.name"
        :hint="fieldsSaved.name && 'Сохранено'"
        @change="update('name', $event)"
      )
    v-col
      .mb-3: strong Тип
      select-course-type(
        :value="moduleItem.type"
        :persistent-hint="fieldsSaved.type"
        :hint="fieldsSaved.type && 'Сохранено'"
        @input="update('type', $event)"
      )
    v-col(cols=12)(v-if="moduleItem.type !== $conf.COURSE_TYPES.qualification")
      .mb-3: strong Направленность
      direction-select(
        :value="moduleItem.direction"
        :persistent-hint="fieldsSaved.direction"
        :hint="fieldsSaved.direction && 'Сохранено'"
        @input="update('direction', $event)"
      )
    v-col(cols=12)(v-if="moduleItem.type !== $conf.COURSE_TYPES.qualification")
      .mb-3: strong Ограничения по возрасту
      .d-flex.align-center
        v-text-field(
          :value="moduleItem.min_age"
          placeholder="Минимальный возраст"
          type="number"
          filled
          rounded
          :persistent-hint="fieldsSaved.min_age"
          :hint="fieldsSaved.min_age && 'Сохранено'"
          @change="update('min_age', $event)"
        )
        .mb-7.mx-6 -
        v-text-field(
          :value="moduleItem.max_age"
          placeholder="Максимальный возраст"
          type="number"
          filled
          rounded
          :persistent-hint="fieldsSaved.max_age"
          :hint="fieldsSaved.max_age && 'Сохранено'"
          @change="update('max_age', $event)"
        )

    v-col(cols=12)
      .mb-3: strong Описание модуля
      v-textarea(
        :value="moduleItem.description"
        placeholder="Описание вашего модуля будет отображаться на бирже"
        filled
        rounded
        :persistent-hint="fieldsSaved.description"
        :hint="fieldsSaved.description && 'Сохранено'"
        @change="update('description', $event)"
      )
    v-col(cols=12 lg=6).pr-6
      .mb-3
        strong Цена модуля
        .caption
          v-icon(small).mr-2 mdi-information-outline
          span Цена за одного пользователя
      v-text-field(
        :value="moduleItem.price_per_user"
        placeholder="Цена"
        prefix="₽"
        filled
        rounded
        type="number"
        :persistent-hint="fieldsSaved.price_per_user"
        :hint="fieldsSaved.price_per_user && 'Сохранено'"
        @change="update('price_per_user', $event)"
      )
    v-col(cols=12 lg=6).pl-6
      .mb-3
        strong Цена с сопровождением
        .caption
          v-icon(small).mr-2 mdi-information-outline
          span Цена за одного пользователя, с сопровождением
      .d-flex.align-center
        v-text-field(
          :value="moduleItem.price_escort_per_user"
          placeholder="Цена с сопровождением"
          prefix="₽"
          filled
          rounded
          type="number"
          :disabled="!moduleItem.is_escorted"
          :persistent-hint="fieldsSaved.price_escort_per_user || !moduleItem.is_escorted"
          :hint=`
            (fieldsSaved.price_escort_per_user && 'Сохранено')
            || (!moduleItem.is_escorted && 'Без сопровождения')`
          @change="update('price_escort_per_user', $event)"
        )
        tooltip-wrap(
          :text=`
              moduleItem.is_escorted
              ? 'Отключить возможность сопровождения'
              : 'Включить возможность сопровождения'`
        )
          v-btn(
            :color="moduleItem.is_escorted ? 'error darken-2' : 'secondary'"
            fab
            text
            large
            @click="update('is_escorted', !moduleItem.is_escorted)"
          ).ml-3.mb-8.shrink
            v-icon(size=40)
              | {{ moduleItem.is_escorted ? 'mdi-cancel' : 'mdi-plus' }}
    v-col(cols=12)
      tooltip-wrap(
        :value="!!moduleItem.accepted_users_count"
        text="На вашем модуле уже есть подписки"
      )
        v-btn(
          depressed
          color="error darken-2"
          rounded
          fab
          small
          :disabled="moduleItem.accepted_users_count > 0"
          @click="deleteModule"
        ).mr-3
          v-icon mdi-trash-can
      v-btn(
        depressed
        rounded
        @click="cloneModule"
      )
        v-icon mdi-content-copy
        span.ml-2 Клонировать
</template>

<script>
import SelectCourseType from '@/components/InputFields/course/SelectCourseType.vue';
import DirectionSelect from '@/components/InputFields/course/SelectDirection.vue';
import TelegramStorage from '@/components/TelegramStorage.vue';
import GptSettings from '@/components/GPTSettings/index.vue';

export default {
  components: {
    SelectCourseType,
    DirectionSelect,
    TelegramStorage,
    GptSettings,
  },
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
  },
  data: () => ({
    fieldsSaved: {},
  }),
  methods: {
    async update(key, value) {
      await this.moduleItem.update({
        data: { [key]: value },
      });
      this.$set(this.fieldsSaved, key, true);
      setTimeout(() => this.$set(this.fieldsSaved, key, false), 2000);
    },
    deleteModule() {
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Удаление модуля',
        message: 'Подтверждаете, что удаляете модуль со всеми его темами без возможности восстановления',
        method: async () => {
          await this.moduleItem.delete();
          this.$toasted.success('Модуль успешно удален');
          this.$router.push({ name: 'ModulesManagementLead', query: { refresh: true } });
        },
      });
    },
    cloneModule() {
      this.$modals.show('confirm-controller', {
        title: 'Клонирование модуля',
        message: 'Конфигурация и все темы модуля будут клонированы',
        method: async () => {
          await this.moduleItem.clone();
          this.$toasted.success('Модуль успешно клонирован');
          this.$router.push({ name: 'ModulesManagementLead', query: { refresh: true } });
        },
      });
    },
  },
};
</script>
